import React, { useReducer, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import GridItemContainer from '../../componentes/form-grids/GridItemContainer';
import CustomAlert from '../../componentes/alerts/CustomAlert';
import GridInputRow from '../../componentes/form-grids/GridInputRow';
import { Grid, Button, Typography, responsiveFontSizes } from '@material-ui/core';
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import { DefaultAutocomplete } from '../../componentes/autocomplete/DefaultAutocomplete';
import { IconLabelSwitch } from "../../componentes/iconSwitch/IconLabelSwitch";
import LabelSuccess from '../../componentes/labels/LabelSuccess';
import LabelError from '../../componentes/labels/LabelError';
import { DefaultDatagrid } from '../../componentes/datagrid/DefaultDatagrid';
import productService from "./ProductService";
import ProductTagParametersDialog from "./ProductTagParametersDialog";
import {
    FaHome,
    FaLink,
    FaUnlink
} from "react-icons/fa";
import InputField from "../../componentes/form-fields/InputField/InputField";

export default function Product() {
    const { t } = useTranslation();
    const { control } = useForm();



    const userId = sessionStorage.getItem("userId");
    const loggedUserIdRole = sessionStorage.getItem("role");

    const initialProductState = {
        idProduto: 0,
        description: '',
        productGroup: 0,
        productCode: '',
        qttybox: 0,
        status: 1,
        userId: userId,
        warningProduct: false,
        warningMessage: '',
    };


    const [product, setProduct] = useState(initialProductState);

    const { idProduto, description, productGroup, productCode, qttybox, status, warningProduct, warningMessage } = product

    const [clearedProduct, setClearedProduct] = useState(false);
    const [programRoleRows, setProductRows] = useState([]);
    const [message, setMessage] = useState("");
    const [error, setError] = useState(warningProduct);
    const [success, setSuccess] = useState(false);

    const columnsProduct = (t) => [
        {
            field: "idProduto",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="id" />;
            },
        },
        {
            field: "description",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="description" name="status" />;
            },
        },
        {
            field: "productCode",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="productCode" name="status" />;
            },
        },
        {
            field: "status",
            textAlign: 'center',
            headerTemplate: () => {
                return <IconLabelSwitch isHeader={true} labelName="statusCode" name="status" />;
            },
            template: (props) => {
                return (
                    <>
                        <Typography>{props.status == 0 ? t("canceled") : t("active")}</Typography>
                    </>
                );
            },
        },
    ];


    const handleChange = (event) => {
        const { name, value } = event.target;
        setProduct({ ...product, [name]: value });
    };

    const handleCloseAlertProduct = () => {
        setProduct({ ...product, warningProduct: false });
    };

    const handleClearProduct = () => {
        setClearedProduct(!clearedProduct);
        setProduct(initialProductState);
        setProductRows([]);
    };

    const handleSearchProduct = () => {
        let request = { ...product }
        productService
            .get(request)
            .then((response) => {

                response.data.forEach((program, index) => {
                    program.id = index
                    program.idRole = request.idRole
                })
                setProductRows(response.data)
            })
            .catch((e) => {
            });
    };

    const handleSaveProduct = () => {
        debugger;
        let request = { ...product }

        setMessage("");
        setSuccess(false);
        setProduct({ ...product, warningProduct: false });
        productService
            .create(request)
            .then((response) => {
                setProduct({ ...product, id: response.data.idProduto });
                setProductRows(response.data)
                setMessage(t("saveSuccess"));
                setSuccess(true);
                handleSearchProduct();
            })
            .catch((e) => {
                setMessage(t("saveError"));
                handleWarningProduct();
            });
    };

    const handleWarningProduct = () => {
        setProductRows([]);
        if (product.idRole !== 0) {
            setProduct({ ...product, warningProduct: true });
        }
    };

    const handleClickGrid = (rowData) => {
        setMessage("");
        setSuccess(false);

        setProduct({
            idProduto: rowData.idProduto
            , description: rowData.description
            , productCode: rowData.productCode
            , productGroup: rowData.productGroup
            , qttybox: rowData.qttyBox
            , status: rowData.status
        })
    }

    useEffect(() => {
        handleSearchProduct();
    }, [product.idRole]);

    return (
        <>
            <DefaultScreenAccordion
                isConsult
                title="product"
                fields={
                    <>
                        <GridItemContainer>
                            <CustomAlert
                                success={success}
                                message={message}
                                warning={warningProduct}
                                handleCloseAlert={handleCloseAlertProduct}
                                snackbar
                                autoClose
                            />
                            <GridInputRow>
                                <Grid item xs={12} sm={12} md={12}>
                                    <InputField
                                        name="description"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={description}
                                        length={50}
                                        error={warningProduct && description === ""}
                                    />
                                </Grid>
                            </GridInputRow>
                            <GridInputRow>
                                <Grid item xs={4} sm={3} md={3}>
                                    <DefaultAutocomplete
                                        name={"productGroup"}
                                        onChange={handleChange}
                                        value={productGroup}
                                        label={t("productGroup")}
                                        defaultSize
                                        useApi
                                        endpoint='GetProductGroupListAutoComplete'
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} md={3}>
                                    <InputField
                                        name="productCode"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={productCode}
                                        length={50}
                                        error={warningProduct && description === ""}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} md={3}>
                                    <InputField
                                        name="qttybox"
                                        control={control}
                                        defaultValue=""
                                        onChange={handleChange}
                                        value={qttybox}
                                        length={50}
                                        error={warningProduct && description === ""}
                                        inputProps={{ type: "number" }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={3} md={3}>
                                    <DefaultAutocomplete
                                        name={"status"}
                                        onChange={handleChange}
                                        value={status}
                                        label={t("status")}
                                        defaultSize
                                        items={[
                                            { id: 0, name: t("canceled"), status: 1 },
                                            { id: 1, name: t("active"), status: 1 },
                                            { id: 2, name: t("all"), status: 1 },
                                        ]}
                                    />
                                </Grid>
                            </GridInputRow>
                            <SearchClearSaveRow
                                onClickClear={handleClearProduct}
                                onClickSearch={handleSearchProduct}
                                onClickSave={handleSaveProduct}
                                customButtons={
                                    <>
                                        {idProduto !== 0 &&
                                            <Grid item>
                                                <ProductTagParametersDialog
                                                    _idProduto={idProduto} />
                                            </Grid>}
                                    </>
                                }
                            />

                        </GridItemContainer>
                    </>
                }
            />
            {programRoleRows.length > 0 ? (
                <DefaultScreenAccordion

                    fields={
                        <DefaultDatagrid
                            columns={columnsProduct(t, handleSearchProduct)}
                            dataSource={programRoleRows}
                            cellSelected={(args, grid) => handleClickGrid(args.data)}
                        />
                    } />
            ) : null}
        </>
    );
};
